export const HANDLE_VISIBLE_EDITMODAL = 'HANDLE_VISIBLE_EDITMODAL';
export const SET_PORTAL_ACTIVE_TAB_KEY = 'SET_PORTAL_ACTIVE_TAB_KEY';
